module.exports = __webpack_public_path__ + "static/media/ico-wallet.39631049.svg";